import { isDate } from 'date-fns';
import { Property, PropertyType } from './types';

// returns a list of properties based on the input data
export const getPropertiesForData = (data: any[], deep: boolean): Property[] => {
  const properties: Property[] = [];

  for (const item of data) {
    for (const [key, value] of Object.entries(item)) {
      const property = properties.find((p) => p.key === key);
      const type = getDcuplPropertyTypeForNativeType(value);
      if (property) {
        if (property.type !== type) {
          property.type = 'any';
        }
      } else {
        const prop: Property = {
          key: key,
          type: type,
        } as any;
        properties.push(prop);
      }
    }
    if (!deep) {
      break;
    }
  }

  return properties;
};

export const isInt = (n: any): boolean => {
  return Number(n) === n && n % 1 === 0;
};

export const isFloat = (n: any): boolean => {
  return Number(n) === n && n % 1 !== 0;
};

export const getDcuplPropertyTypeForNativeType = (value: any): PropertyType => {
  const type = typeof value;

  switch (type) {
    case 'string':
      return 'string';
    case 'number':
      if (isInt(value)) {
        return 'int';
      } else if (isFloat(value)) {
        return 'float';
      } else {
        return 'any';
      }
    case 'boolean':
      return 'boolean';
    case 'object':
      return isDate(value) ? 'date' : 'json';
    default:
      return 'any';
  }
};
